export default __webpack_public_path__ + "static/meet-instructors-3dd67d10404556b867a0a7d4d4e42da1.png";